import React, { useState } from "react";
import { Tabs } from "antd";
import PageLayout from "../../UI/PageLayout";
import { ProductPerformancePageDropdowns } from "./ProductPerformancePageDropdowns";
import OverviewTab from "./OverviewTab";
import LtrTab from "./LtrTab";
import CohortTab from "./CohortTab";

const { TabPane } = Tabs;

const ProductPerformancePage = () => {
  const [activeKey, setActiveKey] = useState("1");

  const renderTabContent = () => {
    switch (activeKey) {
      case "1":
        return <OverviewTab />;
      case "2":
        return <LtrTab />;
      case "3":
        return <CohortTab />;
      default:
        return null;
    }
  };

  return (
    <PageLayout
      title={"Product Performance"}
      dropdowns={<ProductPerformancePageDropdowns tabKey={activeKey} />}
      content={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          <Tabs activeKey={activeKey} onChange={setActiveKey}>
            <TabPane tab="Overview" key="1" />
            <TabPane tab="LTR" key="2" />
            <TabPane tab="Cohort" key="3" />
          </Tabs>
          <div>{renderTabContent()}</div>
        </div>
      }
    />
  );
};

export default ProductPerformancePage;
